import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import { Grid , Paper, Divider, Typography, Box } from '@material-ui/core'
import Settings from 'containers/Examination/ExaminationEditor/BottomMenu/Settings'
import AddQuestion from 'containers/Examination/ExaminationEditor/BottomMenu/AddQuestion'
import QuestionItem from './Presentation/QuestionItem'

import { getExaminationDetails, getExaminationQuestions } from 'containers/Examination/ExaminationService'
import { ExamContext } from 'containers/Examination/ExaminationContext'

import './Examination.css'

const ExaminationEditor = (props) => {
  const id = props.match.params.exam
  const [exam, setExam] = useState({})
  const [questions, setQuestions] = useState([])

  const getExamDetails = async () => {
    let exam = await getExaminationDetails(id)
    setExam(exam)
  }

  const getQuestions = async () => {
    const questionsResponse = await getExaminationQuestions(exam.id)
    setQuestions(questionsResponse)
  }

  useEffect(() => {
    getExamDetails()
  }, [])

  useEffect(() => {
    if (exam.id !== undefined) {
      getQuestions()
    }
  }, [exam])

  return (
    <ResponsiveLayout>
      <ExamContext.Provider value={{exam}}>
        <Grid container lg={8} style={{margin: '0 auto'}}>
          <Paper className="w-full ">
            <Box className="p-5" display="flex">
              <Box className="exam-details-container" flexGrow={1}>
                <Link to={`/examinations`}>
                  <i className="fa fa-arrow-left"></i> All Examinations
                </Link>
                <Typography variant="h4">{exam.name}</Typography>
                <Typography variant="subtitle1">{exam.description}</Typography>
              </Box>
            </Box>
            <Divider />
            <Box className="p-5 exam-questions">

              {questions?.length > 0 &&
                questions.map((q) => (
                  <QuestionItem
                    key={q.id}
                    question={q}
                    onUpdate={getQuestions}
                  />
                ))
              }

              {questions?.length === 0 &&
                <Box display={`felx`} justifyContent={`center`} style={{textAlign: 'center'}}>
                  <Typography variant="subtitle1">No questions added yet</Typography>
                </Box>
              }

            </Box>
            <Box className="editor-actions">
              <AddQuestion onQuestionCreated={getQuestions} />
              <Settings />
            </Box>
          </Paper>
        </Grid>
      </ExamContext.Provider>
    </ResponsiveLayout>
  )
}

export default ExaminationEditor;